<div class="fc" *ngIf="cards.length">
  <div class="fc-progress">
    <span class="fc-progress__count">Card {{index + 1}} of {{cards.length}}</span>
    <div class="fc-dots">
      <button type="button" *ngFor="let c of cards; let i = index" class="fc-dot"
        [class.fc-dot--current]="i === index" [class.fc-dot--done]="confirmed.has(c.id)"
        (click)="goTo(i)" [attr.aria-label]="'Go to card ' + (i + 1)"></button>
    </div>
    <span class="fc-progress__tally">{{confirmedCount}}/{{cards.length}} confirmed</span>
  </div>

  <div class="fc-stage" *ngIf="!result">
    <button type="button" class="fc-nav" (click)="previous()" [disabled]="index === 0" aria-label="Previous card">
      <i class="fa fa-angle-left"></i>
    </button>

    <div class="fc-card" [class.fc-card--flipped]="flipped" [class.fc-card--done]="isCurrentConfirmed" (click)="flip()">
      <div class="fc-card__inner">
        <div class="fc-card__face fc-card__face--front">
          <span class="fc-card__eyebrow">Question</span>
          <p class="fc-card__text">{{current?.front}}</p>
          <span class="fc-card__hint"><i class="fa fa-sync-alt"></i> Tap to flip</span>
        </div>
        <div class="fc-card__face fc-card__face--back">
          <span class="fc-card__eyebrow fc-card__eyebrow--back">Answer</span>
          <p class="fc-card__text">{{current?.back}}</p>
          <span class="fc-card__hint fc-card__hint--done" *ngIf="isCurrentConfirmed">
            <i class="fa fa-check-circle"></i> Confirmed
          </span>
          <span class="fc-card__hint" *ngIf="!isCurrentConfirmed"><i class="fa fa-sync-alt"></i> Tap to flip back</span>
        </div>
      </div>
    </div>

    <button type="button" class="fc-nav" (click)="next()" [disabled]="index === cards.length - 1" aria-label="Next card">
      <i class="fa fa-angle-right"></i>
    </button>
  </div>

  <div class="fc-actions" *ngIf="!result">
    <button type="button" class="btn btn--sm m-0 fc-gotit" (click)="gotIt()" [disabled]="!flipped || isCurrentConfirmed">
      <i class="fa fa-check"></i> {{isCurrentConfirmed ? 'Confirmed' : 'Got it'}}
    </button>
    <button type="button" class="btn m-0 fc-finish" [disabled]="!allConfirmed || submitting" (click)="finish()">
      Finish review
    </button>
  </div>
  <p class="fc-hint-text" *ngIf="!result && !allConfirmed">Flip each card and tap "Got it" before finishing.</p>

  <div class="fc-done" *ngIf="result">
    <div class="fc-done__badge"><i class="fa fa-check"></i></div>
    <p class="fc-done__title">All {{cards.length}} cards reviewed</p>
    <p class="fc-done__sub">Attempt recorded.</p>
  </div>
</div>
